import { categories } from '@/mocks/homeData';

type TopicsSectionProps = {
  activeCategory: string;
  onSelect: (id: string) => void;
};

export default function TopicsSection({ activeCategory, onSelect }: TopicsSectionProps) {
  return (
    <section id="topics" aria-labelledby="topics-title" className="scroll-mt-28 bg-background-100">
      <div className="mx-auto max-w-[1400px] px-4 py-14 md:px-6 md:py-20">
        <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
          <div>
            <p className="text-xs tracking-[0.25em] text-primary-600">TOPICS</p>
            <h2
              id="topics-title"
              className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-4xl"
            >
              主题分类
            </h2>
          </div>
          <p className="max-w-md text-sm leading-relaxed text-foreground-600">
            点击任意分类,直接跳到下方对应的爆料列表,快速找到你关心的那一类热点。
          </p>
        </div>

        <ul className="mt-8 grid grid-cols-2 gap-4 md:grid-cols-3 lg:grid-cols-6">
          {categories.map((cat) => {
            const isActive = activeCategory === cat.id;
            return (
              <li key={cat.id}>
                <button
                  type="button"
                  onClick={() => onSelect(cat.id)}
                  className={`flex h-full w-full cursor-pointer flex-col items-start gap-3 rounded-lg border p-4 text-left transition-colors ${
                    isActive
                      ? 'border-primary-400 bg-primary-50'
                      : 'border-background-200 bg-background-50 hover:border-primary-300'
                  }`}
                >
                  <span
                    className={`flex h-10 w-10 items-center justify-center rounded-md text-xl ${
                      isActive ? 'bg-primary-500 text-background-50' : 'bg-secondary-100 text-secondary-800'
                    }`}
                  >
                    <i className={cat.icon} aria-hidden="true" />
                  </span>
                  <span className="w-full">
                    <span className="block text-sm font-medium text-foreground-950">{cat.name}</span>
                    <span className="mt-1 block text-xs text-foreground-500">{cat.count} 条内容</span>
                  </span>
                </button>
              </li>
            );
          })}
        </ul>
      </div>
    </section>
  );
}